import { api } from './api'
import { DrugRecall, DrugRecallFormData, AffectedPatient } from '../types/drugRecall'

export const drugRecallService = {
  /**
   * Get all drug recalls
   */
  getAll: async (): Promise<DrugRecall[]> => {
    const response = await api.get<DrugRecall[]>('/drug-recalls')
    return response.data
  },

  /**
   * Get a single drug recall by ID
   */
  getById: async (id: string): Promise<DrugRecall> => {
    const response = await api.get<DrugRecall>(`/drug-recalls/${id}`)
    return response.data
  },

  /**
   * Create a new drug recall
   */
  create: async (data: DrugRecallFormData): Promise<DrugRecall> => {
    const response = await api.post<DrugRecall>('/drug-recalls', data)
    return response.data
  },

  /**
   * Update an existing drug recall
   */
  update: async (id: string, data: Partial<DrugRecallFormData>): Promise<DrugRecall> => {
    const response = await api.put<DrugRecall>(`/drug-recalls/${id}`, data)
    return response.data
  },

  /**
   * Delete a drug recall
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`/drug-recalls/${id}`)
  },

  /**
   * Get affected patients for a recall
   */
  getAffectedPatients: async (recallId: string): Promise<AffectedPatient[]> => {
    const response = await api.get<AffectedPatient[]>(`/drug-recalls/${recallId}/affected-patients`)
    return response.data
  },

  /**
   * Search patients by medication
   */
  searchPatientsByMedication: async (drugId: string): Promise<AffectedPatient[]> => {
    const response = await api.get<AffectedPatient[]>(`/patient-medication-search?drugId=${drugId}`)
    return response.data
  },

  /**
   * Create recall notifications for affected patients
   */
  createRecallNotifications: async (recallId: string): Promise<{ tasksCreated: number; patientsNotified: number }> => {
    const response = await api.post<{ tasksCreated: number; patientsNotified: number }>(
      `/drug-recalls/${recallId}/notifications`
    )
    return response.data
  },
}
